import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "template-picker__item" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "template-picker__title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("input", {
      id: $options.id,
      checked: $props.checked,
      type: "radio",
      class: "radio",
      name: "template-picker",
      onChange: _cache[0] || (_cache[0] = (...args) => ($options.onCheck && $options.onCheck(...args)))
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: $options.id,
      class: "template-picker__label"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["template-picker__preview", $data.failedPreview ? 'template-picker__preview--failed' : ''])
      }, [
        _createElementVNode("img", {
          class: "template-picker__image",
          src: $options.realPreviewUrl,
          alt: "",
          draggable: "false",
          onError: _cache[1] || (_cache[1] = (...args) => ($options.onFailure && $options.onFailure(...args)))
        }, null, 40, _hoisted_4)
      ], 2),
      _createElementVNode("span", _hoisted_5, _toDisplayString($options.nameWithoutExt), 1)
    ], 8, _hoisted_3)
  ]))
}